import React, { useEffect, useState } from "react";
import ToolBar from "../common-web/ToolBar";

// Example image array (replace with your images)
import projectImg1 from "../../assets/img/project-img.png";
import projectImg2 from "../../assets/img/project-img.png";
import projectImg3 from "../../assets/img/project-img.png";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import loader from "../../assets/img/loader.gif";

export default function LineupContent() {
  const images = [projectImg1, projectImg2, projectImg3];
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading for 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    // cleanup
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex-1 flex flex-col relative h-[calc(100vh-50px)] overflow-hidden bg-white border-l border-black/15">
      {/* Background image slider */}
      <div className="w-full h-full relative">
        {loading ? (
          <div className="w-full h-full flex justify-center items-center ">
            <img src={loader} alt="" className="" />
          </div>
        ) : (
          images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt=""
              className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
                index === current ? "opacity-100" : "opacity-0"
              }`}
            />
          ))
        )}
        {/* Overlay Content */}
        {/* Toolbar  */}
        <ToolBar />
        {/* off/ on  */}
        <div className="absolute lg:top-6 sm:top-[120px] top-[160px] right-6 p-2 bg-[#E6E6E6] flex items-center gap-2.5 rounded-[10px] backdrop-blur-[75px] ">
          {[
            {
              color: "bg-[#FFA600]",
              text: (
                <>
                  OFF <br /> CLOSE
                </>
              ),
            },
            {
              color: "bg-[#007BFF]",
              text: (
                <>
                  ON <br /> OPEN
                </>
              ),
            },
          ].map((it, idx) => (
            <div key={idx} className="flex items-center gap-2.5">
              <div className="w-9 aspect-square bg-white rounded-[6px] flex items-center justify-center">
                <div
                  className={`w-4 rounded-full aspect-square ${it.color}`}
                ></div>
              </div>

              <p className="text-[#242424] text-[11px]">{it.text}</p>
            </div>
          ))}
        </div>
        {/* Navigation buttons */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2  text-white rounded-full p-2 transition"
        >
          <SlArrowLeft color="#fff" size={36} />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2  text-white rounded-full p-2 transition"
        >
          <SlArrowRight color="#fff" size={36} />
        </button>
      </div>
    </div>
  );
}
